import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  WorkflowHistoryResponse,
  WorkflowLogEntry,
} from '../../models/workflow-history.model';
import { JobMap, JobName } from './log.constants';
import { mapLogResponseToModel } from './log.mapper';

@Injectable({
  providedIn: 'root',
})
export class LogsService {
  http = inject(HttpClient);

  getLog$ = (
    jobName: JobName,
    regionId?: number,
  ): Observable<WorkflowLogEntry[]> =>
    this.http
      .get<WorkflowHistoryResponse>(
        `logs/history?jobName=${JobMap[jobName]}${regionId ? `&regionid=${regionId}` : ''}`,
      )
      .pipe(map((response) => this.parseResponse(response)));

  getLogByMappedName$ = (
    mappedJobName: string,
    regionId?: number,
  ): Observable<WorkflowLogEntry[]> =>
    this.http
      .get<WorkflowHistoryResponse>(
        `logs/history?jobName=${mappedJobName}${regionId ? `&regionid=${regionId}` : ''}`,
      )
      .pipe(map((response) => this.parseResponse(response)));

  getLogEntryDetails$ = (correlationId: string) =>
    this.http
      .get<WorkflowHistoryResponse>(
        `logs/details?correlationId=${correlationId}`,
      )
      .pipe(map((response) => this.parseResponse(response)));

  private parseResponse(
    response?: WorkflowHistoryResponse,
  ): WorkflowLogEntry[] {
    return response?.data.map((r) => mapLogResponseToModel(r)) || [];
  }
}
